<template lang='pug'>
.search-for-asset
	.search-bar-wrapper
		span.red.text-error(v-if='hasErrors' v-for='( error, key ) in displayError') Your \#{{ parseInt( key, 10 ) + 1 }} item {{ error.toLowerCase() }}
		simple-search(
			:options='{ placeholder : options.placeholder }'
			@search='searchQuery = $event'
		)
	.search-results-wrapper
		p.spacey.loading-indicator(v-if='state === "loading"') loading
			span .
			span .
			span .
		p.spacey(v-if='state === "loaded" && !results.length') no results
</template>

<script>
import SimpleSearch from '@/components/SimpleSearch';

export default {
	name : 'search-for-asset',

	props : {

		errors : {
			type : [Boolean, Object, String],
		},

		value : {
			type : Array,
		},

		options : {
			type : Object,
		}

	},

	data : () => ( {
		state : 'ready',

		searchQuery : '',
		results     : [],

		displayError : null,
	} ),

	computed : {

		hasErrors() {
			return !!this.displayError;
		},

	},

	watch : {

		errors : {
			immediate : true,
			handler( errors ) {
				this.displayError = errors;
			}
		},

		searchQuery( query ) {

			if ( !query ) {
				this.state = 'ready';

				return;
			}

			this.state = 'loading';

			this.options.search( query )
				.then( ( results ) => {
					this.results = results;
					this.state   = 'loaded';
				} )
				.catch( () => {
					this.state = 'failed';
				} );

		}

	},

	components : {
		SimpleSearch,
	}
};
</script>

<style lang='scss'>
.search-for-asset {

	.search-bar-wrapper {
		width: 100%;
	}

	.search-results-wrapper {

		p.spacey {
			text-align: center;
			margin-top: 10px;
		}
	}
}
</style>
